import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { rtkQueryErrorLogger } from './middleware';
// persists store
import storageSession from "redux-persist/lib/storage/session"
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { combineReducers } from 'redux';
import homeReducer, { sliceName as homeSliceKey } from './../pages/home/homeSlice'
import policyDocumentReducer, { sliceName as policyDocKey } from "../layouts/policy-documents/PolicyDocumentSlice"
import onboardingClientReducer, { sliceName as onboardingClientSliceKey } from './onboardingClientSlice';
import pricingMatrixReducer, { sliceName as priceMatrixKey } from "./PricingMatrixSlice"
import RFQFieldworkReducer, { sliceName as RFQFieldworkSliceKey } from "./RFQFieldworkSlice"
import TaasTableSectionSlice, { sliceName as TaasTableSliceKey } from '../components/taas-cost-estimate/taas-table-section/TaasTableSectionSlice';
import priceChartReducer, { sliceName as priceChartKey } from "./PriceChartSlice"
import { onboardNewClientApi } from '../services/crp/onboardingClient'
import { countriesApi } from '../services/countries'
import loginAuthReducer, { sliceName as authSliceKey } from "./LoginAuthSlice";
import mainNavReducer, { sliceName as mainNavKey } from '../components/main-navbar/MainNavSlice';
import { addClientPathApi } from "../services/add-client/addClient";
import { caseStudyApi } from '../services/curated/caseStudy'
import { OutlookCalendarApi } from '../services/crp/outlookCalendar'
import rfqMarketResearchReducer, { sliceName as rfqSliceKey } from '../pages/rfq/rfqMarketingResearchSlice';
import endClientSliceReducer, { sliceName as endClientSliceKey } from "./EndClientSlice"
import ProposalTemplateEndClientSlice, { sliceName as proposalTemplateEndClientSliceKey } from '../layouts/proposal-template/ProposalTemplateEndClientSlice';
import { faqApi } from '../services/curated/faq';
import { collateralLinksApi } from '../services/curated/collateralLinks';
import { countriesListApi } from '../services/country-list/countryCodeListApi';
import PitchDeckSlice, { sliceName as pitchDeckKey } from './PitchDeckSlice';
import PitchDeckSliceV2, { sliceName as pitchDeckV2Key } from './PitchDecksliceV2';
import CollaborationSlice, { sliceName as CollaborationKey } from './CollaborationSlice';
import { REACT_APP_RTK_DEVTOOLS_STATE } from '../config/reactConstant';

const reducers = combineReducers({
  [homeSliceKey]: homeReducer,
  [policyDocKey]: policyDocumentReducer,
  [onboardingClientSliceKey]: onboardingClientReducer,
  [priceMatrixKey]: pricingMatrixReducer,
  [priceChartKey]: priceChartReducer,
  [authSliceKey]: loginAuthReducer,
  [mainNavKey]: mainNavReducer,
  [onboardNewClientApi.reducerPath]: onboardNewClientApi.reducer,
  [countriesApi.reducerPath]: countriesApi.reducer,
  [addClientPathApi.reducerPath]: addClientPathApi.reducer,
  [caseStudyApi.reducerPath]: caseStudyApi.reducer,
  [OutlookCalendarApi.reducerPath]: OutlookCalendarApi.reducer,
  [collateralLinksApi.reducerPath]: collateralLinksApi.reducer,
  [countriesListApi.reducerPath]: countriesListApi.reducer,
  [rfqSliceKey]: rfqMarketResearchReducer,
  [RFQFieldworkSliceKey]: RFQFieldworkReducer,
  [endClientSliceKey]: endClientSliceReducer,
  [TaasTableSliceKey]: TaasTableSectionSlice,
  [proposalTemplateEndClientSliceKey]: ProposalTemplateEndClientSlice,
  [pitchDeckKey]: PitchDeckSlice,
  [pitchDeckV2Key]: PitchDeckSliceV2,
  [CollaborationKey]: CollaborationSlice
})

const persistedReducer = persistReducer({
  key: 'root',
  storage: storageSession,
  stateReconciler: autoMergeLevel2,
  whitelist: [authSliceKey]
}, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
    }
  }).concat(
    rtkQueryErrorLogger,
    onboardNewClientApi.middleware,
    addClientPathApi.middleware,
    caseStudyApi.middleware,
    OutlookCalendarApi.middleware,
    faqApi.middleware,
    collateralLinksApi.middleware,
    countriesListApi.middleware
  ),
  devTools: REACT_APP_RTK_DEVTOOLS_STATE
});

setupListeners(store.dispatch);







